import React, { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function MonthYearPicker({ label, value, onChange }) {
  const handleChange = (newValue) => {
    onChange(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={["year", "month"]} // <-- Only Year & Month
        label={label}
        value={value}
        onChange={handleChange}
        minDate={dayjs("2000-01-01")}
        maxDate={dayjs("2100-12-31")}
        format="YYYY-MM" // Display format
      />
    </LocalizationProvider>
  );
}

// Example usage in a parent component
// function ParentComponent() {
//   const [selectedDate, setSelectedDate] = useState(dayjs());

//   return (
//     <MonthYearPicker
//       label="Select Month & Year"
//       value={selectedDate}
//       onChange={setSelectedDate}
//     />
//   );
// }
